import React, { Component } from 'react';
import ContentWrapper from '../../../components/Layout/ContentWrapper';

class BalanceCellFormatter extends Component {
  render() {
    const { dependentValues: { UnpaidAmount, DiscountedAmount } } = this.props;
    const discountedAmount = DiscountedAmount || 0;
    return (
      <ContentWrapper>
        {
          React.cloneElement(this.props.children, {
            value: (UnpaidAmount - discountedAmount).toFixed(2),
          })
        }
      </ContentWrapper>
    );
  }
}

export default BalanceCellFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/CreateAP/BalanceCellFormatter.jsx